import { Link } from "react-router-dom";
import { BookOpen, HelpCircle, Users } from "lucide-react";
import { SIGN_FACTS, cap, faqFor } from "@/lib/signFacts";
import { pairSlug } from "@/pages/CompatibilityPage";

// Evergreen "traits and dates" FAQ (+ FAQPage structured data) and best-match pair links for a sign page.
export function SignFaq({ sign }) {
  const faq = faqFor(sign);
  const ld = { "@context": "https://schema.org", "@type": "FAQPage",
    mainEntity: faq.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })) };
  return (
    <section data-testid="sign-faq" className="mt-8 bg-[#0F1523]/90 border border-[#D4AF37]/20 rounded-2xl p-5">
      <h2 className="flex items-center gap-2 text-xl font-light mb-3"><HelpCircle size={18} className="gold-text" /> {cap(sign)} traits and dates</h2>
      <dl className="space-y-4">
        {faq.map(([q, a], i) => (
          <div key={q} data-testid={`sign-faq-item-${i}`}>
            <dt className="text-base text-starlight">{q}</dt>
            <dd className="text-sm leading-relaxed text-[#A7B0C0] mt-1">{a}</dd>
          </div>
        ))}
      </dl>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }} />
    </section>
  );
}

export function BestMatches({ sign }) {
  const f = SIGN_FACTS[sign];
  return (
    <>
    <Link to={`/signs/${sign}`} data-testid="link-sign-guide" className="mt-4 flex items-center justify-between bg-[#0F1523]/90 border border-[#D4AF37]/30 hover:border-[#D4AF37]/60 rounded-2xl p-5 transition-colors">
      <span className="flex items-center gap-2 text-lg font-light"><BookOpen size={18} className="gold-text" /> Read the full {cap(sign)} guide</span>
      <span className="text-xs gold-text">Personality, love, career and more</span>
    </Link>
    <section data-testid="sign-best-matches" className="mt-4 bg-[#0F1523]/90 border border-[#D4AF37]/20 rounded-2xl p-5">
      <h2 className="flex items-center gap-2 text-xl font-light mb-1"><Users size={18} className="gold-text" /> Best matches for {cap(sign)}</h2>
      <p className="text-sm text-[#A7B0C0] mb-3">Tap a pair to read the full compatibility guide.</p>
      <div className="flex flex-wrap gap-2">
        {f.matches.map((m) => (
          <Link key={m} to={`/compatibility/${pairSlug(sign, m)}`} data-testid={`sign-match-${m}`}
            className="whitespace-nowrap text-sm border border-[#D4AF37]/30 hover:bg-[#D4AF37]/10 text-[#E8DCC4] rounded-full px-4 py-2 transition-colors">
            {cap(sign)} <span className="gold-text">×</span> {cap(m)}
          </Link>
        ))}
      </div>
    </section>
    </>
  );
}
